<!-- top bar: back arrow + project title -->

<app-progress-bar-loader *ngIf="isLoading" [loadingText]="'Your data is getting retrieved,\n Please wait.'"></app-progress-bar-loader>
<ng-container *ngIf="!isLoading">

    <div class="page-header">
        <button mat-icon-button (click)="goBack()" aria-label="Back to projects">
      <mat-icon>arrow_back</mat-icon>
    </button>
        <span class="project-title">{{ projectName }}</span>
    </div>

    <!-- section heading + CTA -->
    <div class="section-bar">
        <h3>Sniff Test Reports</h3>

        <span class="spacer"></span>

        <button *ngIf="workflows().length>0" mat-raised-button class="run-sniff-test-button" color="primary" (click)="runSniffTest()">
      Run Sniff Test
    </button>
    </div>

    <div *ngIf="workflows().length==0" class="centered-create-workflow-div">
        <div class="centered-text">
            No Sniff Test Reports found, Please click on “Run Sniff Test” button to get started.
        </div>
        <button mat-raised-button class="run-sniff-test-button" color="primary" (click)="runSniffTest()">
        Run Sniff Test
      </button>
    </div>

    <!-- reports table -->
    <table *ngIf="workflows().length>0" mat-table [dataSource]="workflows()" class="reports-table" matSort matSortDisableClear>

        <!-- Name -->
        <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef>Report Name</th>
            <td mat-cell *matCellDef="let row" [ngStyle]="{cursor:'pointer'}">{{ row.workflowName }}</td>
        </ng-container>

        <!-- Status -->
        <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef>Status</th>
            <td mat-cell *matCellDef="let row">
                <span [ngClass]="{
                    'status-pending': row.status == 'pending',
                    'status-completed': row.status == 'completed',
                    'status-failed': row.status == 'failed'
                }">{{ row.status }}</span>
            </td>
        </ng-container>

        <!-- Type -->
        <ng-container matColumnDef="type">
            <th mat-header-cell *matHeaderCellDef>Type</th>
            <td mat-cell *matCellDef="let row">{{ row.type=='infringement'?'Infringe Fusion':row.type=='pas'?'Invalidity Check':row.type }}</td>
        </ng-container>

        <!-- Created -->
        <ng-container matColumnDef="created">
            <th mat-header-cell *matHeaderCellDef>Created</th>
            <td mat-cell *matCellDef="let row">
                {{ row.createdAt | date: 'yyyy-MM-dd hh:mm a' }}
            </td>
        </ng-container>

        <!-- Actions -->
        <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef class="actions-col">Actions</th>
            <td mat-cell *matCellDef="let row" class="actions-col">
                <button mat-icon-button [matMenuTriggerFor]="rowMenu" (click)="$event.stopPropagation()">
          <mat-icon>more_vert</mat-icon>
        </button>
                <mat-menu #rowMenu="matMenu">
                    <button mat-menu-item (click)="renameWorkflow(row)">
            <mat-icon>edit</mat-icon>
            Rename
          </button>
                    <button mat-menu-item (click)="deleteWorkflow(row)">
            <mat-icon>delete</mat-icon>
            Delete
          </button>
                </mat-menu>
            </td>
        </ng-container>

        <!-- header row -->
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>

        <!-- conditional row rendering -->
        <ng-container *ngIf="!isLoading; else loadingRows">
            <tr mat-row *matRowDef="let row; columns: displayedColumns" (click)="redirectToReport(row)"></tr>
        </ng-container>

    </table>

    <!-- loading spinner -->
    <ng-template #loadingRows>
        <tr>
            Hi
            <td [attr.colspan]="displayedColumns.length">
                <div style="display: flex; justify-content: center; padding: 2rem;">
                    <mat-spinner></mat-spinner>
                </div>
            </td>
        </tr>
    </ng-template>
</ng-container>